/**
 * Vue2应用入口文件
 * 中华非遗项目主入口
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// Font Awesome
import '@fortawesome/fontawesome-free/css/all.css'

// 全局样式
import './styles/main.css'

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 